import axios from "axios";
import { toast } from "react-toastify";
import {
  setSchDirection,
  handleSchedulingStatus,
} from "../../../slice/learnSlice";
import TPC_URL from "../../../utils/TPC_URL";

function formatTimeMs(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours === 0 && minutes === 0) {
    return `${seconds}초`;
  }
  if (hours === 0) {
    return `${minutes}분 ${seconds}초`;
  }
  return `${hours}시 ${minutes}분 ${seconds}초`;
}

export const useScheduling = (
  dispatch,
  isCancelled,
  openSnackbar,
  setUpdateStatus,
  group_code,
  project_code,
  setLoading,
  setLoadingMessage,
  loadingMessage,
  dateValue,
  scheOptions,
  setUpdateStatus2
) => {
  const handleDoScheduling = async (
    selectedModel,
    data,
    excludedOrderIds=[],
    doSchedulingMutation
  ) => {
    // if (!data.length) {
    //   openSnackbar(
    //     "주문이 존재하지 않습니다. 주문을 추가 후 다시 시도해 주세요.",
    //     "info"
    //   );
    //   return;
    // }
    
    isCancelled.current = false;
    if (isCancelled.current) return;
    setLoading(true);
    
    try {
      const bodyObj = {
        excludeOrders: excludedOrderIds,
        project_code,
        group_code,
      };
      
      await doSchedulingMutation.mutateAsync(bodyObj, {
        onError: (error) => {
          setLoading(false);
          console.log(`onError`);
          let errorMessage =
            "스케줄링 데이터를 생성하던 도중 에러가 발생하였습니다.";
          try {
            if (error && error.response) {
              if (error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
              } else if (typeof error.response.data === "string") {
                errorMessage = error.response.data;
              } else if (error.response.status) {
                errorMessage = `서버 오류가 발생했습니다 (${error.response.status}).`;
              }
            } else if (error && error.message) {
              errorMessage = error.message;
            }
          } catch (e) {
            console.error("에러 메시지 파싱 중 오류 발생:", e);
            errorMessage = "알 수 없는 오류가 발생했습니다.";
          }
          toast.error(errorMessage);
        },
      });
      
      if (isCancelled.current) return;
      
      const res = await axios.post(TPC_URL + "/api/tpc/start", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          group_code,
          project_code,
          date: dateValue?.format("YYYY-MM-DD HH:mm"),
          isSecond: false,
        },
      });
      
      if (isCancelled.current) return;
      
      if (res.data.message === "생성할 데이터가 없습니다.") {
        setLoading(false);
        setLoadingMessage("");
        openSnackbar("생성할 데이터가 없습니다.", "info");
        dispatch(handleSchedulingStatus());
        return;
      }

      if (res.data.message === "작업이 시작되었습니다.") {
        toast.success(res.data.message);
        setLoadingMessage("일정계획 수행을 요청하였습니다.");
        startStatusCheck();  // ✅ scheOptions 전달
        const statusParams = {
          isScheduling: true,
          processStatus: 1,
        };
        dispatch(handleSchedulingStatus(statusParams));
      } else if (
        res.data.message ===
        "작업이 요청되었습니다. 현재 다른 작업이 진행 중이므로 대기열에 추가되었습니다."
      ) {
        toast.success(res.data.message);
        startStatusCheck();  // ✅ scheOptions 전달
        const statusParams = {
          isScheduling: true,
          processStatus: 1,
        };
        dispatch(handleSchedulingStatus(statusParams));
      } else if (res.data.message === "이미 동작중입니다.") {
        openSnackbar(res.data.message);
      } else if (!res.data.success) {
        openSnackbar(res.data.message, "error");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      openSnackbar("오류가 발생했습니다.", "error");
      console.log(error);
    }
  };
  
  const startStatusCheck = () => {
    let isSecondStartDone = false;
    let isProcessingApiCall = false;
    let statusCallCount = 0;

    const intervalId = setInterval(async () => {
      try {
        if (isCancelled.current) return;

        if (isProcessingApiCall) {
          return;
        }

        const statusRes = await axios.get(
          TPC_URL +
            `/api/tpc/status?group_code=${group_code}&project_code=${project_code}`
        );
        
        statusCallCount++;

        if (statusRes.data?.message === "생성할 데이터가 없습니다.") {
          clearInterval(intervalId);
          setLoading(false);
          setLoadingMessage("");
          openSnackbar("생성할 데이터가 없습니다.", "info");
          dispatch(handleSchedulingStatus());
          return;
        }

        const { code } = statusRes.data.status;
        
        const progressPercent = statusRes.data?.progress_percent 
          ? parseFloat(statusRes.data.progress_percent).toFixed(1) 
          : "0.0";
        
        // ✅ scheOptions === 1 (임시페이지 사용) 분기
        if (scheOptions === 1) {
          // 진행 중 메시지
          if (code !== 3) {
            setLoadingMessage(`임시 테이블을 사용하여 일정계획 수립 진행중... ${progressPercent}% 완료`);
          }
          
          // code === 3이면 바로 종료
          if (code === 3) {
            isProcessingApiCall = true;
            try {
              await axios.get(
                TPC_URL +
                  `/api/tpc/initiate?group_code=${group_code}&project_code=${project_code}&code=1`
              );
              setLoadingMessage("");
              setLoading(false);
              openSnackbar("일정계획 생성을 완료하였습니다.");
              clearInterval(intervalId);
              handleCompletion(`${statusCallCount}초`);
            } catch (error) {
              console.error("Error in final initiate:", error);
              isProcessingApiCall = false;
            }
          }
          return;  // ✅ scheOptions === 1이면 여기서 끝
        }
        
        // ✅ scheOptions === 0 (엑셀 사용) - 기존 로직
        if (code === 3) {
          setLoadingMessage("일정계획 수립 결과를 정리하고 있습니다.");
        }
        
        if (statusRes.data.isGenerateNumber === 1 && !isSecondStartDone) {
          if (code !== 3) {
            setLoadingMessage(`용접공정 생산계획 수립 진행중... ${progressPercent}% 완료`);
          }
          
          if (code === 3) {
            isProcessingApiCall = true;

            try {
              const initiateRes = await axios.get(
                TPC_URL +
                  `/api/tpc/initiate?group_code=${group_code}&project_code=${project_code}`
              );
              
              if (initiateRes.status === 200) {
                const secondReqRes = await axios.post(
                  TPC_URL + "/api/tpc/generateSecond",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: {
                      group_code,
                      project_code,
                    },
                  }
                );
                
                if (secondReqRes.data?.message === "생성할 데이터가 없습니다.") {
                  clearInterval(intervalId);
                  setLoading(false);
                  setLoadingMessage("");
                  openSnackbar("생성할 데이터가 없습니다.", "info");
                  dispatch(handleSchedulingStatus());
                  isProcessingApiCall = false;
                  return;
                }

                const secondStartRes = await axios.post(
                  TPC_URL + "/api/tpc/start",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: {
                      group_code,
                      project_code,
                      isSecond: true,
                    },
                  }
                );
                
                if (secondStartRes.data?.message === "생성할 데이터가 없습니다.") {
                  clearInterval(intervalId);
                  setLoading(false);
                  setLoadingMessage("");
                  openSnackbar("생성할 데이터가 없습니다.", "info");
                  dispatch(handleSchedulingStatus());
                  isProcessingApiCall = false;
                  return;
                }

                if (secondStartRes.data.message === "작업이 시작되었습니다.") {
                  setLoadingMessage("일정계획 수립을 진행중입니다.");
                  isSecondStartDone = true;
                  isProcessingApiCall = false;
                } else {
                  isProcessingApiCall = false;
                }
              } else {
                isProcessingApiCall = false;
              }
            } catch (error) {
              console.error("Error in second start process:", error);
              isProcessingApiCall = false;
            }
          }
        } else if (statusRes.data.isGenerateNumber === 2) {
          if (code !== 3) {
            setLoadingMessage(`절단공정 생산계획 수립 진행중... ${progressPercent}% 완료`);
          }
          
          if (code === 3) {
            isProcessingApiCall = true;
            try {
              await axios.get(
                TPC_URL +
                  `/api/tpc/initiate?group_code=${group_code}&project_code=${project_code}&code=2`
              );
              setLoadingMessage("");
              setLoading(false);
              openSnackbar("일정계획 생성을 완료하였습니다.");
              clearInterval(intervalId);
              handleCompletion(`${statusCallCount}초`);
            } catch (error) {
              console.error("Error in final initiate:", error);
              isProcessingApiCall = false;
            }
          }
        }
      } catch (error) {
        console.error("Status check error:", error);
        clearInterval(intervalId);
        setLoading(false);
      }
    }, 1000);
  };
  
  const handleCompletion = async (elapsedTime) => {
    toast.success(`완료되었습니다. 소요시간 : ${elapsedTime}`);
    dispatch(handleSchedulingStatus());
    setLoading(false);
    try {
      setLoadingMessage("재고 상태를 업데이트하는 중입니다...");
      setLoading(true);
      const storageKey = `temp_instruction_${group_code}_${project_code}`;
      localStorage.removeItem(storageKey);
        await axios.post(`${TPC_URL}/api/tpc/updateStockInfoStatus`, {
        group_code,
        project_code,
      });
      setUpdateStatus((prev) => !prev);
      setUpdateStatus2((prev) => !prev);
      toast.success("재고 상태가 업데이트되었습니다.");
    } catch (error) {
      console.error("Error updating stock info status:", error);
      toast.error("재고 상태 업데이트 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };
    
  const handleCancelScheduling = async (selectedModel) => {
    isCancelled.current = true;
    try {
      const res = await axios.post(TPC_URL + "/api/tpc/cancel", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          group_code,
          project_code,
        },
      });
      
      const statusParams = {
        isScheduling: true,
        processStatus: 9,
      };
      const completeStatusParams = {
        isScheduling: false,
        processStatus: 0,
      };
      
      if (res.data.message === "이미 완료된 작업은 취소할 수 없습니다.") {
        dispatch(handleSchedulingStatus(completeStatusParams));
        setLoading(false);
        openSnackbar("일정계획 생성을 취소하였습니다.", "info");
        setLoadingMessage("");
      }
      
      if (
        res.data.success ||
        res.data.message === "작업 취소가 요청되었습니다." ||
        res.data.message === "작업 요청이 취소되었습니다."
      ) {
        dispatch(handleSchedulingStatus(statusParams));
        setLoadingMessage("일정계획 수립 취소를 요청하였습니다.");
        
        const intervalId = setInterval(async () => {
          try {
            if (!isCancelled.current) return;
            
            const statusRes = await axios.get(
              TPC_URL +
                `/api/tpc/status?group_code=${group_code}&project_code=${project_code}`
            );
            
            const { status } = statusRes.data;
            
            if (status.code === 9 || status.code === 0) {
              dispatch(handleSchedulingStatus(completeStatusParams));
              setLoading(false);
              openSnackbar("일정계획 생성을 취소하였습니다.", "info");
              setLoadingMessage("");
              clearInterval(intervalId);
            }
          } catch (error) {
            console.error("Status check error:", error);
            clearInterval(intervalId);
            setLoading(false);
            setLoadingMessage("");
            dispatch(handleSchedulingStatus(completeStatusParams));
            openSnackbar("취소 중 오류가 발생하였습니다.", "error");
          }
        }, 1000);
      }
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };
  
  return {
    handleDoScheduling,
    handleCancelScheduling,
    setLoading,
  };
};

// export const useScheduling = (
//   dispatch,
//   isCancelled,
//   openSnackbar,
//   setUpdateStatus,
//   group_code,
//   project_code,
//   setLoading,
//   setLoadingMessage,
//   loadingMessage,
//   dateValue
// ) => {
//   const handleDoScheduling = async (
//     selectedModel,
//     data,
//     excludedOrderIds,
//     doSchedulingMutation
//   ) => {
//     if (!data.length) {
//       openSnackbar(
//         "주문이 존재하지 않습니다. 주문을 추가 후 다시 시도해 주세요.",
//         "info"
//       );
//       return;
//     }

//     isCancelled.current = false;
//     if (isCancelled.current) return;
//     setLoading(true);
    
//     try {
//       // const bodyObj = {
//       //   excludeOrders: excludedOrderIds,
//       //   project_code,
//       //   group_code,
//       // };
      
//       // console.log("bodyObj : ", bodyObj);
      
//       // await doSchedulingMutation.mutateAsync(bodyObj, {
//       //   onError: (error) => {
//       //     setLoading(false);
//       //     console.log(`onError`);
//       //     let errorMessage =
//       //       "스케줄링 데이터를 생성하던 도중 에러가 발생하였습니다.";
//       //     try {
//       //       if (error && error.response) {
//       //         if (error.response.data && error.response.data.message) {
//       //           errorMessage = error.response.data.message;
//       //         } else if (typeof error.response.data === "string") {
//       //           errorMessage = error.response.data;
//       //         } else if (error.response.status) {
//       //           errorMessage = `서버 오류가 발생했습니다 (${error.response.status}).`;
//       //         }
//       //       } else if (error && error.message) {
//       //         errorMessage = error.message;
//       //       }
//       //     } catch (e) {
//       //       console.error("에러 메시지 파싱 중 오류 발생:", e);
//       //       errorMessage = "알 수 없는 오류가 발생했습니다.";
//       //     }
//       //     toast.error(errorMessage);
//       //   },
//       // });

//       // if (isCancelled.current) return;

//       // start 한 번만 실행
//       const res = await axios.post(TPC_URL + "/api/tpc/start", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           group_code,
//           project_code,
//           date: dateValue?.format("YYYY-MM-DD HH:mm"),
//           isSecond: false,
//         },
//       });

//       if (isCancelled.current) return;

//       // "생성할 데이터가 없습니다." 메시지 확인
//       if (res.data.message === "생성할 데이터가 없습니다.") {
//         setLoading(false);
//         setLoadingMessage("");
//         openSnackbar("생성할 데이터가 없습니다.", "info");
//         dispatch(handleSchedulingStatus());
//         return;
//       }

//       if (res.data.message === "작업이 시작되었습니다.") {
//         toast.success(res.data.message);
//         setLoadingMessage("일정계획 수립을 진행중입니다.");
//         startStatusCheck();
//         const statusParams = {
//           isScheduling: true,
//           processStatus: 1,
//         };
//         dispatch(handleSchedulingStatus(statusParams));
//       } else if (
//         res.data.message ===
//         "작업이 요청되었습니다. 현재 다른 작업이 진행 중이므로 대기열에 추가되었습니다."
//       ) {
//         toast.success(res.data.message);
//         startStatusCheck();
//         const statusParams = {
//           isScheduling: true,
//           processStatus: 1,
//         };
//         dispatch(handleSchedulingStatus(statusParams));
//       } else if (res.data.message === "이미 동작중입니다.") {
//         openSnackbar(res.data.message);
//       } else if (!res.data.success) {
//         openSnackbar(res.data.message, "error");
//         setLoading(false);
//       }
//     } catch (error) {
//       setLoading(false);
//       openSnackbar("오류가 발생했습니다.", "error");
//       console.log(error);
//     }
//   };

//   const startStatusCheck = () => {
//     let isProcessingApiCall = false; // API 호출 중 플래그

//     const intervalId = setInterval(async () => {
//       try {
//         if (isCancelled.current) {
//           clearInterval(intervalId);
//           return;
//         }

//         // 다른 API 호출 중이면 status 체크 건너뛰기
//         if (isProcessingApiCall) {
//           return;
//         }

//         const statusRes = await axios.get(
//           TPC_URL +
//             `/api/tpc/status?group_code=${group_code}&project_code=${project_code}`
//         );

//         // "생성할 데이터가 없습니다." 메시지 확인
//         if (statusRes.data?.message === "생성할 데이터가 없습니다.") {
//           clearInterval(intervalId);
//           setLoading(false);
//           setLoadingMessage("");
//           openSnackbar("생성할 데이터가 없습니다.", "info");
//           dispatch(handleSchedulingStatus());
//           return;
//         }

//         const { code } = statusRes.data.status;

//         // code === 3 (완료)일 때만 initiate 호출 후 종료
//         if (code === 3) {
//           isProcessingApiCall = true;

//           try {
//             const msTime = formatTimeMs(statusRes.data.finTime);
            
//             // initiate 호출 (완료 처리)
//             await axios.get(
//               TPC_URL +
//                 `/api/tpc/initiate?group_code=${group_code}&project_code=${project_code}`
//             );

//             // 완료 처리
//             setLoadingMessage("");
//             setLoading(false);
//             openSnackbar("일정계획 생성을 완료하였습니다.");
//             clearInterval(intervalId);
//             handleCompletion(msTime);
//           } catch (error) {
//             console.error("Error in initiate:", error);
//             setLoading(false);
//             setLoadingMessage("");
//             openSnackbar("완료 처리 중 오류가 발생했습니다.", "error");
//             clearInterval(intervalId);
//           } finally {
//             isProcessingApiCall = false;
//           }
//         } else {
//           // code === 1 (대기) or code === 2 (진행중)
//           setLoadingMessage("일정계획 수립을 진행중입니다.");
//         }
//       } catch (error) {
//         console.error("Status check error:", error);
//         clearInterval(intervalId);
//         setLoading(false);
//         setLoadingMessage("");
//         openSnackbar("상태 확인 중 오류가 발생했습니다.", "error");
//       }
//     }, 500);
//   };

//   const handleCompletion = (elapsedTime) => {
//     toast.success(`완료되었습니다. 소요시간 : ${elapsedTime}`);
//     dispatch(handleSchedulingStatus());
//     setLoading(false);
//   };

//   const handleCancelScheduling = async (selectedModel) => {
//     isCancelled.current = true;
//     try {
//       const res = await axios.post(TPC_URL + "/api/tpc/cancel", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           group_code,
//           project_code,
//         },
//       });

//       const statusParams = {
//         isScheduling: true,
//         processStatus: 9,
//       };
//       const completeStatusParams = {
//         isScheduling: false,
//         processStatus: 0,
//       };

//       if (res.data.message === "이미 완료된 작업은 취소할 수 없습니다.") {
//         dispatch(handleSchedulingStatus(completeStatusParams));
//         setLoading(false);
//         openSnackbar("일정계획 생성을 취소하였습니다.", "info");
//         setLoadingMessage("");
//         return;
//       }

//       if (
//         res.data.success ||
//         res.data.message === "작업 취소가 요청되었습니다." ||
//         res.data.message === "작업 요청이 취소되었습니다."
//       ) {
//         dispatch(handleSchedulingStatus(statusParams));
//         setLoadingMessage("일정계획 수립 취소를 요청하였습니다.");

//         const intervalId = setInterval(async () => {
//           try {
//             if (!isCancelled.current) return;

//             const statusRes = await axios.get(
//               TPC_URL +
//                 `/api/tpc/status?group_code=${group_code}&project_code=${project_code}`
//             );

//             const { status } = statusRes.data;

//             if (status.code === 9 || status.code === 0) {
//               dispatch(handleSchedulingStatus(completeStatusParams));
//               setLoading(false);
//               openSnackbar("일정계획 생성을 취소하였습니다.", "info");
//               setLoadingMessage("");
//               clearInterval(intervalId);
//             }
//           } catch (error) {
//             console.error("Status check error:", error);
//             clearInterval(intervalId);
//             setLoading(false);
//             setLoadingMessage("");
//             dispatch(handleSchedulingStatus(completeStatusParams));
//             openSnackbar("취소 중 오류가 발생하였습니다.", "error");
//           }
//         }, 1000);
//       }
//     } catch (e) {
//       console.error(e);
//       setLoading(false);
//     }
//   };

//   return {
//     handleDoScheduling,
//     handleCancelScheduling,
//     setLoading,
//   };
// };
